import type { FaireProductEntity } from "../../entity_types/product";

export const p_c7p96vp64m: FaireProductEntity = {
  token: "p_c7p96vp64m",
  type: "product",
  name: "Cats and Moons Socks",
  brandToken: "b_7a21757f",
  brandName: "Benjamin International",
  imageUrl:
    "https://cdn.faire.com/fastly/0e6ce14be2e40e710afcfcea9e6b626a0307397ce67bf465b04736e55022d017.jpeg",
  galleryImageUrls: [],
  priceDollars: 3.75,
  description:
    "All socks are carded.\n• 'Socks with Benefits - 10% of the profits will be donated to charity\n• Women's size 9-11\n• Men's 7-12",
  tags: [],
  msrpDollars: 7.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:25.801Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
